export const useThemeColor = () => {
    const updateThemeColor = (color: string) => {
        let meta: HTMLMetaElement | null = document.querySelector('meta[name="theme-color"]')
        if (!meta) {
            meta = document.createElement('meta')
            meta.name = 'theme-color'
            document.head.appendChild(meta)
        }
        meta.setAttribute('content', color)
    }

    return { updateThemeColor }
}

export default useThemeColor
